import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { buildHeaderEntity, getPrivateAreaBaseAPI } from '../../mulesoftService/mulesoft.entity';
import { CheckInsMyMSCResponse } from '@msc-b2c/interfaces/interfaces';

export const checkinApi = createApi({
  reducerPath: 'checkin',
  baseQuery: fetchBaseQuery({
    baseUrl: getPrivateAreaBaseAPI(),
    prepareHeaders: (headers) => {
      const headersEntity = buildHeaderEntity(true);
      const entityHeaders = headersEntity.toHeaders();
      Object.entries(entityHeaders).forEach(([key, value]) => {
        headers.set(key, value as string);
      });
      return headers;
    },
  }),
  tagTypes: ['Checkins'],
  endpoints: (builder) => ({
    getCheckins: builder.query<CheckInsMyMSCResponse, { bookingNumber: string; cabinId: string }>({
      query: ({ bookingNumber, cabinId }) =>
        `/bookings/${bookingNumber}/cabins/${cabinId}/checkIns`,
      providesTags: ['Checkins'],
    }),
  }),
});

export const { useGetCheckinsQuery, useLazyGetCheckinsQuery } = checkinApi;
